import { Component, Input, Inject, OnInit } from '@angular/core';
import { ItemShipDetail } from '../../../Models/item-ship-detail';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material';
import { DialogShowJustificationsComponent } from '../dialog-show-justifications/dialog-show-justifications.component';
import { Justification } from 'src/app/Models/justification';
import { ShipDetailEnum } from 'src/app/enums/ship-detail-enum';
import { ApiService } from 'src/app/core/services/api.service';
import { MessageService } from 'src/app/core/services/message.service';

@Component({
    selector: 'dialog-show-items',
    templateUrl: './dialog-show-items.component.html',
    styleUrls: ['./dialog-show-items.component.scss']
})

export class DialogShowItemsComponent implements OnInit {

  
  items: ItemShipDetail[] = [];
  statusItem = ShipDetailEnum;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,
              private apiService: ApiService,
              private messageService: MessageService) {

  }

  ngOnInit(): void {
    this.items = this.data;
  }

  openJustifications(itemDetail: ItemShipDetail) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    let dialogRef = this.dialog.open(DialogShowJustificationsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data: Justification) => {
      if (data) {
        let selectedJustification = data;
        itemDetail.justification = selectedJustification;
        itemDetail.statusDetail = ShipDetailEnum.REJECTED_CLIENT;
        this.saveItemDetail(itemDetail);
      }
    });
  }

  saveItemDetail(item: ItemShipDetail) {
    this.apiService.put('api/itemShipDetail', item).subscribe((response: any) => {
      if(response.data){
        this.messageService.success('Éxito', 'Se ha rechazado el material correctamente.');
      }
    });
  }
}
